import { Field, FixedOptionTextOutput, NumericInput, TextOutput } from 'Components/Core';
import { IFieldProps } from 'Components/Core/Field/types';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import {
  WorksheetBatchUpdateEquipmentDisplayField,
  WorksheetBatchUpdateEquipmentSelectionField,
  WorksheetBatchUpdateImportSourceField,
} from 'Components/WorksheetBatchUpdate/Core/SpecialisedFieldComponents';
import { WorksheetBatchUpdateWorksheetFieldSection } from 'Components/WorksheetBatchUpdate/types';
import React from 'react';
import { WorksheetBatchUpdateWorksheetField } from '../..';

export const ArizNuclearFieldDensityWorksheetSections: {
  [name: string]: WorksheetBatchUpdateWorksheetFieldSection;
} = {
  preparation: {
    heading: 'Preparation',
  },
  laboratoryDensity: {
    heading: 'Reference Maximum Density',
  },
  measurements: {
    heading: 'Measurements',
  },
};

export const ArizNuclearFieldDensityWorksheetFields: {
  [name: string]: WorksheetBatchUpdateWorksheetField;
} = {
  'data.Preparation.NuclearDensityGauge': {
    displayComponent: <WorksheetBatchUpdateEquipmentDisplayField />,
    entryComponent: <WorksheetBatchUpdateEquipmentSelectionField equipmentType="nuclear-density-gauge" />,
    displayFieldsWhenEntered: [
      'data.Preparation.NuclearDensityGaugeSerialNumber',
      'data.Preparation.NuclearDensityGaugeMakeAndModel',
    ],
    isImportSource: true,
    equipmentDetails: {
      calibrationImportMismatchField: 'data.Preparation.NuclearDensityGaugeCalibratedImportMismatch',
      propertiesImportMismatchField: 'data.Preparation.NuclearDensityGaugePropertiesImportMismatch',
    },
    section: 'preparation',
  },
  'data.Preparation.NuclearDensityGaugeSerialNumber': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Preparation.NuclearDensityGaugeMakeAndModel': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Preparation.DensityStandardCount': {
    displayComponent: <Field input={<TextOutput />} />,
    entryComponent: <Field input={<NumericInput />} />,
    section: 'preparation',
  },
  'data.Preparation.MoistureStandardCount': {
    displayComponent: <Field input={<TextOutput />} />,
    entryComponent: <Field input={<NumericInput />} />,
    section: 'preparation',
  },
  'data.ReferenceDensity.ImportedTest': {
    /**
     * Special display component - extract meaningful string from imported test model
     */
    displayComponent: React.createElement(
      withInjectedProps<IFieldProps>(({ value, ...otherFieldProps }) => (
        <Field
          {...otherFieldProps}
          input={<TextOutput />}
          value={value?.Results?.ReferenceId ?? value?.Sample?.SampleId}
        />
      ))
    ),
    entryComponent: <WorksheetBatchUpdateImportSourceField importPropertyName={'ReferenceDensity'} />,
    alsoSets: ['data.ReferenceDensity.AssociatedTestType'],
    displayFieldsWhenEntered: [
      'data.Results.MaximumDryDensity',
      'data.Results.OptimumMoistureContent',
      'data.Results.RelativeCompaction',
      'data.Results.MoistureVariation',
    ],
    isImportSource: true,
    section: 'laboratoryDensity',
  },
  'data.Measurements.NuclearDensityGaugeMode': {
    displayComponent: <Field input={<FixedOptionTextOutput />} />,
  },
  'data.Measurements.Depth': {
    displayComponent: <Field input={<TextOutput />} />,
    entryComponent: <Field input={<NumericInput />} />,
    displayFieldsWhenEntered: ['data.Measurements.NuclearDensityGaugeMode'],
    section: 'measurements',
  },
  'data.Results.MaximumDryDensity': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.OptimumMoistureContent': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.RelativeCompaction': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.MoistureVariation': {
    displayComponent: <Field input={<TextOutput />} />,
  },
};

export default ArizNuclearFieldDensityWorksheetFields;
